module.exports = __webpack_public_path__ + "static/media/add-client-icon.7925de91.svg";